import { useEffect } from 'react';
import { useGameState } from './GameStateContext';

/**
 * Validates the enhanced move structure
 * @param {Object} move - Move object to validate
 * @param {number} index - Index in moves array
 * @returns {boolean} - Whether the move has the correct structure
 */
export function validateMoveStructure(move, index) {
  const requiredFields = ['notation', 'moveNum', 'content', 'arrows', 'opening', 'analysis'];
  const missingFields = requiredFields.filter(field => !(field in move));
  
  if (missingFields.length > 0) {
    // console.warn(`Move at index ${index} is missing required fields: ${missingFields.join(', ')}`);
    return false;
  }
  
  // Validate moveNum is correct
  const expectedMoveNum = Math.floor(index / 2) + 1;
  if (move.moveNum !== expectedMoveNum) {
    // console.warn(`Move at index ${index} has incorrect moveNum: ${move.moveNum} (expected ${expectedMoveNum})`);
  }
  
  // Validate analysis structure
  if (!move.analysis || typeof move.analysis !== 'object') {
    // console.warn(`Move at index ${index} has invalid analysis structure`);
    return false;
  }
  
  const analysisFields = ['pvs', 'scores', 'classification', 'depth'];
  const missingAnalysisFields = analysisFields.filter(field => !(field in move.analysis));
  
  if (missingAnalysisFields.length > 0) {
    // console.warn(`Move at index ${index} is missing analysis fields: ${missingAnalysisFields.join(', ')}`);
    return false;
  }
  
  return true;
}

/**
 * Hook to validate the move structure in the current game state
 */
export function useMoveValidator() {
  const { state } = useGameState();
  
  useEffect(() => {
    if (state.moves && state.moves.length > 0) {
      // 
      const validMoves = state.moves.map((move, index) => validateMoveStructure(move, index));
      const allValid = validMoves.every(valid => valid);
      
      if (allValid) {
        // 
      } else {
        // console.warn('✗ Some moves are missing required fields');
      }
      
      // Sample the first move to show the structure
      if (state.moves.length > 0) {
        // 
      }
    }
  }, [state.moves]);
}

// Default function to setup the initial game state
export default function SetupDefaults() {
  const { dispatch } = useGameState();
  
  // Validate move structure
  useMoveValidator();
  
  // Default effect to set up the standard starting position
  useEffect(() => {
    dispatch({
      type: 'SET_INITIAL_POSITION',
      payload: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
    });
  }, [dispatch]);
  
  return null;
}
